import AnalyticSallersSubPage from "./analytic-sellers-sub-page";


const SubPage = {
    Sallers: AnalyticSallersSubPage,
};

export default SubPage;
